/**
 * **************************************************************************
 * Dashboard - summary service file
 * 
 * Defines all http api calls required in summary page
 * Calls server apis and returns data to components
 * **************************************************************************
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SummaryService {

  /****************** Variable declaration ******************/
  /* Defined urls */
  private summaryUrl = this.apiService.KPID_URL + this.apiService.DASHBOARD_APIS.SUMMARY.DASHBOARD;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  /**
   * Retrieve the summary of workflows executed
   * @returns 
   */
  getWfSummary(days: number, wfId: number): Observable<any> {
    const url = this.summaryUrl + this.apiService.DASHBOARD_APIS.SUMMARY.WF_SUMMARY(days, wfId);
    let response = this.httpClient.get(url);
    return response;
  }
  private selectedTabIndexSubject = new BehaviorSubject<number>(0);
  selectedTabIndex$ = this.selectedTabIndexSubject.asObservable();

  /** Method to update the selected tab index */
  updateSelectedTabIndex(index: number) {
    this.selectedTabIndexSubject.next(index);
  }
}
